import React from "react";
import PropTypes from "prop-types";
import { Input } from "antd";

const Search = Input.Search;

const SearchBox = ({ value, placeholder, onChange, className, width }) => {
  return (
    <div className="search-box">
      <Search
        className={className}
        placeholder={placeholder}
        onSearch={onChange}
        onChange={(e) => onChange(e.target.value)}
        style={{ width: width || 500 }}
        value={value}
      />
    </div>
  );
};

SearchBox.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string,
  width: PropTypes.string,
};

SearchBox.defaultProps = {
  value: "",
  onChange: () => {},
};

export default SearchBox;
